// extracted by mini-css-extract-plugin
export default {"title":"styles_title__wPAiw","go-to-login-button":"styles_go-to-login-button__PqQV6","support":"styles_support__dJ1tJ","subtitle":"styles_subtitle__1djZv"};